import { SignInPasswordlessConfirmationBase } from '@/app_components/SignIn/Confirmations/SignInPasswordlessConfirmationBase';

interface PasswordlessConfirmationProps {
  email: string;
}

export const SignInPasswordlessNewAccountConfirmation = ({ email }: PasswordlessConfirmationProps) => {
  const headerText = 'Check your email to verify your account';
  const subheaderText = `A sign-in link is on its way to ${email}. Click it to finish creating your account.`;

  return (
    <SignInPasswordlessConfirmationBase
      headerText={headerText}
      resendEmail={email}
      subheaderText={subheaderText}
    />
  );
};
